import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static values = {
		turboFrameId: String,
		updateSrcOnConnect: { type: Boolean, default: true }
	}

	connect() {
		if (this.updateSrcOnConnectValue) {
			this.updateTurboFrameSrc()
		}
	}

	updateTurboFrameSrc() {
		const inputElement = this.element
		let newSrc = null
		if (inputElement.nodeName == "SELECT") {
			newSrc = inputElement.options[inputElement.selectedIndex].value
		} else {
			newSrc = inputElement.value
		}

		const turboFrame = document.getElementById(this.turboFrameIdValue)
		turboFrame.src = newSrc

		//console.log(`updated ${turboFrame} src to ${newSrc}`)
	}
}

